import Link from 'next/link';
import { ButtonHTMLAttributes, forwardRef, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

export interface IconButtonProps extends PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement>> {
    as?: 'button' | 'link';
    href?: string;
    target?: string;
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
    ({ children, className = '', as = 'button', href = '', target = '', ...rest }, ref) => {
        const classes =
            'relative flex items-center content-center justify-center cursor-pointer border-none text-black w-6';
        const component = (
            <button ref={ref} data-testid="icon-button" className={twMerge(classes, className)} {...rest}>
                {children}
            </button>
        );

        return (
            // Typing a polymorphic component here can be a bit tricky, especially with forwarding refs. Leaving this as a TODO for now. https://www.benmvp.com/blog/forwarding-refs-polymorphic-react-component-typescript/ may be a good place to investigate.
            <>
                {as === 'button' ? (
                    component
                ) : (
                    <Link
                        data-testid="icon-button-link"
                        href={href}
                        target={target}
                        className={twMerge(classes, className)}
                    >
                        {component}
                    </Link>
                )}
            </>
        );
    },
);

export default IconButton;
IconButton.displayName = 'IconButton';
